import { PauseIcon, PlayIcon } from 'lucide-react';
import { useShallow } from 'zustand/react/shallow';

import { Button } from '@nesso/ui/primitives/button';

import { useRecordingControls, useRecordingStore } from '@/entities/audio-recording';

export function RecordingCapturePause() {
    const { status, length } = useRecordingStore(
        useShallow((state) => ({
            status: state.status,
            length: state.length,
        })),
    );

    const { pause, resume } = useRecordingControls();

    return (
        <Button
            variant="default"
            onClick={status === 'recording' ? pause : resume}
            disabled={length === 'too-long'}
            className="h-10"
        >
            {status === 'recording' ? (
                <PauseIcon className="w-4 h-4" />
            ) : (
                <span className="flex items-center gap-2">
                    <PlayIcon className="w-4 h-4" />
                    Resume
                </span>
            )}
        </Button>
    );
}
